import { motion } from "framer-motion";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card, CardContent } from "@/components/ui/card";
import { Star } from "lucide-react";

const testimonials = [
  {
    quote: "I was skeptical at first, but the Buffalo Wild Wings samples were amazing! The flavors were just like in the restaurant.",
    author: "Michael T.",
    location: "Denver, CO",
    avatar: "https://randomuser.me/api/portraits/men/32.jpg"
  },
  {
    quote: "The variety of sauces in the sample pack was impressive. My family loved trying all the different flavors!",
    author: "Sarah J.",
    location: "Austin, TX",
    avatar: "https://randomuser.me/api/portraits/women/44.jpg"
  },
  {
    quote: "Super easy process to claim the samples. They arrived quickly and tasted fantastic. Will definitely be ordering more!",
    author: "David M.",
    location: "Chicago, IL",
    avatar: "https://randomuser.me/api/portraits/men/67.jpg"
  }
];

const TestimonialsSection = () => {
  return (
    <section id="testimonials" className="py-16 md:py-24 bg-secondary/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
              What People Are Saying
            </h2>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Don't just take our word for it. Here's what others have to say about their Buffalo Wild Wings samples.
            </p>
          </motion.div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <Card className="bg-card/50 backdrop-blur-sm border-border h-full">
                <CardContent className="pt-6">
                  <div className="flex flex-col h-full">
                    <div className="flex mb-4">
                      {[...Array(5)].map((_, i) => (
                        <Star key={i} size={18} className="text-yellow-500 fill-yellow-500" />
                      ))}
                    </div>
                    
                    <div className="mb-6">
                      <p className="text-card-foreground italic">"{testimonial.quote}"</p>
                    </div>
                    
                    <div className="mt-auto flex items-center">
                      <Avatar className="h-10 w-10 mr-3">
                        <AvatarImage src={testimonial.avatar} alt={testimonial.author} />
                        <AvatarFallback className="bg-primary/20 text-primary">
                          {testimonial.author.split(' ').map(n => n[0]).join('')}
                        </AvatarFallback>
                      </Avatar>
                      <div>
                        <p className="text-card-foreground font-medium">{testimonial.author}</p>
                        <p className="text-muted-foreground text-sm">{testimonial.location}</p>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          viewport={{ once: true }}
          className="mt-12 text-center"
        >
          <p className="text-lg text-muted-foreground">
            Join thousands of satisfied customers who have already claimed their free Buffalo Wild Wings samples!
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default TestimonialsSection;